import * as React from "react";
import { useState, useCallback, useMemo } from "react";
import styled from "@emotion/styled";
import Form from "react-bootstrap/Form";
import { debounce } from "lodash";
// import { DSDropdown, Item } from "@/components/Core/DSDropdown";
// import { Dropdown as DropdownIcon } from "@/styles/icons";
// import { tokens } from "@/styles/coreConstants";

import { easelFontFamily } from "../../helpers/constants";
import { usePublishModal } from "./usePublishModal";

interface SearchAndFilterProps {
  totalCount: number | null;
}

// TO DO: add back drop downs when custom categories & sorting is available

export const SearchAndFilter: React.FC<SearchAndFilterProps> = (
  props: SearchAndFilterProps
) => {
  const { totalCount } = props;
  const { setQuery } = usePublishModal();

  const [localQuery, setLocalQuery] = useState("");

  const debounceSetQuery = useCallback(
    debounce((value) => {
      setQuery(value);
    }, 200),
    []
  );

  const onSearch: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    setLocalQuery(event.target.value);
    // TO DO: loading indicator?
    debounceSetQuery(event.target.value);
  };

  const show = useMemo(() => {
    return totalCount !== null && totalCount > 0;
  }, [totalCount]);

  return (
    <Wrapper show={show}>
      {/* <LeftWrapper> */}
      {/* <DSDropdown>
          <Toggle>
            All Categories <DropdownIcon fill={easelColors.almostBlack} />
          </Toggle>
          <div>
            <Item>Custom Categories</Item>
          </div>
        </DSDropdown> */}
      <SearchBar
        data-testid="resource-search-bar"
        placeholder="Search"
        value={localQuery}
        onChange={onSearch}
      />
      {/* </LeftWrapper> */}

      {/* <DSDropdown>
        <Toggle>
          Sort: Not a sort <DropdownIcon fill={easelColors.almostBlack} />{" "}
        </Toggle>
        <div>
          <Item>A-Z</Item>
          <Item>Recently Updated</Item>
        </div>
      </DSDropdown> */}
    </Wrapper>
  );
};

const Wrapper = styled.div((props: { show?: boolean }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 0.5rem",
  flexWrap: "wrap",
  minHeight: "3rem",
  fontFamily: easelFontFamily,
  opacity: props.show ? 1 : 0,
  transition: "0.5s opacity ease",
  pointerEvents: props.show ? "initial" : "none",
}));

// TO DO: make sure to keep on one line on smaller screens
// const LeftWrapper = styled.div({
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   height: "100%",
//   minWidth: "70vw",
// });

const SearchBar = styled(Form.Control)({
  // width: "75%",
  width: "100%",
  margin: "1rem 0",
  fontSize: "0.875rem",
  // minWidth: "15rem",
});

// const Toggle = styled.div({
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   fontSize: "0.875rem",
//   fontWeight: 400,
//   border: `1px solid ${tokens["ds-color-gray-lighter"]}`,
//   borderRadius: "0.375rem",
//   height: "2.25rem",
//   lineHeight: "2.25rem",
//   padding: "0 1rem",
//   background: easelColors.white,
//   width: "10rem",
//   fontFamily: easelFontFamily,
// });
